<template>
  <v-row class="text-center">
    <v-col md="3">
      <v-avatar color="orange" size="100">
        <span class="white--text">{{ course.total_enrolled_individual_users }}</span>
      </v-avatar>
      <p class="mt-3">Individial Users</p>
    </v-col>
    <v-col md="3">
      <v-avatar color="teal" size="100">
        <span class="white--text">{{ course.total_groups }}</span>
      </v-avatar>
      <p class="mt-3">Group Users</p>
    </v-col>
    <v-col md="3">
      <v-avatar color="indigo" size="100">
        <span class="white--text">{{ course.total_enrolled_via_channel_users }}</span>
      </v-avatar>
      <p class="mt-3">Channel Users</p>
    </v-col>
    <v-col md="3">
      <v-avatar color="pink" size="100">
        <span class="white--text">{{ course.total_users }}</span>
      </v-avatar>
      <p class="mt-3">Total Users</p>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "CourseStats",
  props: {
    course: {
      type: Object,
      default: null
    }
  }
};
</script>